// extracted by mini-css-extract-plugin
export default {"menu":"Menu_menu__ciIYS","lang-button":"Menu_lang-button__ZhxEp","outdated":"Menu_outdated__0j1Hc","menu-logo":"Menu_menu-logo__Vs6dX","menu-imgs":"Menu_menu-imgs__2JzGl"};